import { Box } from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import shaka from 'shaka-player';

type Props = {
  id: string;
  src: string;
  isPaused?: boolean;
  className?: string;
};

function ShakaPlayer({ src, id, className }: Readonly<Props>) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<shaka.Player | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (shaka.Player.isBrowserSupported()) {
      const player = new shaka.Player();
      playerRef.current = player;

      player.attach(video);

      player.addEventListener('error', (event) => {
        console.error('shaka error:', event);
      });

      player.load(src).catch((error) => {
        console.error('Error loading source:', error);
      });
    } else {
      console.error('shaka not supported');
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [src]);

  return (
    <Box id={id} width="100%" height="100%" className={`shaka-player-${className}`}>
      <video ref={videoRef} style={{ width: '100%', height: 'auto', background: 'black' }} autoPlay />
    </Box>
  );
}

export default ShakaPlayer;
